import { useState } from "react"
import { Accordion, FormError, FormLabel, InputNumber, Modal } from "../../../components/common"
import { useFormErrors } from "../../../components/hooks"

const ConceptoPagoModal = ({ concepto, conceptoPago, onConfirm, onDismiss }) => {
    const [item, setItem] = useState(conceptoPago)

    const rangoCantidad = `${concepto.opcional ? '0 o un número ' : 'un número '}entre ${concepto.cantidadDesde} y ${concepto.cantidadHasta}`

    const getErrors = () => {

        const errors = {}

        if (concepto.admiteCantidad && !(concepto.opcional && item.cantidad === 0)) {
            if (!Number.isInteger(item.cantidad) || item.cantidad < concepto.cantidadDesde || item.cantidad > concepto.cantidadHasta)
                errors.cantidad = `Ingresá ${rangoCantidad}`
        }

        if (concepto.importeEditable) {
            if (concepto.opcional) {
                if (item.importe < 0) errors.importe = 'Ingresá un número mayor o igual a cero'
            }
            else if (item.importe <= 0) errors.importe = 'Ingresá un número mayor a cero'
        }

        return errors
    }

    const { errorOf, validate } = useFormErrors(getErrors)

    const onClickConfirm = () => {
        if (!validate()) return
        onConfirm(item)
    }

    return (
        <Modal
            onEscape={onDismiss}
            show
            header={<h2 className="modal-title">Edición de concepto</h2>}
            body={(
                <Accordion title="Cantidad e importe" startOpen={true}>
                    <div className='row form-basic'>
                        {concepto.admiteCantidad &&
                        <div className="mb-3 col-12 col-md-6">
                            <FormLabel htmlFor="cantidad" required>{`Cantidad (${concepto.opcional ? '0 o ' : ''}entre ${concepto.cantidadDesde} y ${concepto.cantidadHasta})`}</FormLabel>
                            <InputNumber
                                name="cantidad"
                                className={`form-control ${errorOf('cantidad') ? 'is-invalid' : ''}`}
                                precision={0}
                                value={item.cantidad}
                                onChange={({ target }) => setItem(x => ({...x, cantidad: target.value}))}
                            />
                            <FormError message={errorOf('cantidad')} />
                        </div>
                        }
                        {concepto.importeEditable &&
                        <div className="mb-3 col-12 col-md-6">
                            <FormLabel htmlFor="importe" required>Importe</FormLabel>
                            <InputNumber
                                name="importe"
                                className={`form-control ${errorOf('importe') ? 'is-invalid' : ''}`}
                                precision={2}
                                value={item.importe}
                                onChange={({ target }) => setItem(x => ({...x, importe: target.value}))}
                            />
                            <FormError message={errorOf('importe')} />
                        </div>
                        }
                    </div>
                </Accordion>
            )}
            footer={(
                <>
                <button
                    className="btn btn-outline-primary"
                    data-dismiss="modal"
                    onClick={onDismiss}
                >Cancelar</button>
                <button
                    className="btn btn-primary"
                    data-dismiss="modal"
                    onClick={onClickConfirm}
                >Aceptar</button>
                </>
            )}
        />
    )
}

export default ConceptoPagoModal
